import 'angular:locale/data:nl';
import 'angular:locale/data:en-US';
import 'zone.js';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
